var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMapPinSmall = function SvgIconMapPinSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14143C",
    d: "M12 11.143a2.143 2.143 0 1 1 0-4.285 2.143 2.143 0 0 1 0 4.285ZM12 3a6 6 0 0 0-6 6c0 4.5 6 11.143 6 11.143S18 13.5 18 9a6 6 0 0 0-6-6Z"
  })));
};
export default SvgIconMapPinSmall;